import React, { useState, useRef, useEffect, isValidElement, Children, cloneElement } from 'react';
import { isForwardRef } from 'react-is';
import { useMergeRefs } from 'use-callback-ref';
import '../../utils/assertions.es.js';
import { maestroComponent } from '../../utils/componentHelpers.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import { useOnClickOutside } from '../../hooks/useOnClickOutside/useOnClickOutside.es.js';
import '@popperjs/core';
import { useHover } from '../../hooks/useHover/useHover.es.js';
import { useUpdateEffect } from '../../hooks/useUpdateEffect/useUpdateEffect.es.js';
import 'react-beautiful-dnd';
import 'nanoid/non-secure';
import { Popper } from '../../primitives/Popper/Popper.es.js';
import { Fade } from '../Fade/Fade.es.js';
import { Box } from '../../primitives/Box/Box.es.js';
import { Tooltip as Tooltip$1, Content } from './styled.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const TooltipComponent = (_a) => {
  var _b = _a, {
    hasArrow = true,
    maxWidth = "240px",
    fontSize = "xs",
    position = "top",
    isInverted = false,
    hideOnScroll = false,
    children,
    content,
    onOpen,
    onClose
  } = _b, props = __objRest(_b, [
    "hasArrow",
    "maxWidth",
    "fontSize",
    "position",
    "isInverted",
    "hideOnScroll",
    "children",
    "content",
    "onOpen",
    "onClose"
  ]);
  const [open, setOpen] = useState(false);
  const [hoverRef, isHovered] = useHover(hideOnScroll);
  const popperRef = useRef(null);
  const mergedRefs = useMergeRefs([hoverRef, children.ref]);
  useOnClickOutside(popperRef, () => {
    setOpen(false);
  });
  useEffect(() => {
    setOpen(isHovered);
  }, [isHovered]);
  useUpdateEffect(() => {
    open ? onOpen == null ? void 0 : onOpen() : onClose == null ? void 0 : onClose();
  }, [open]);
  const childrenProps = {
    ref: mergedRefs
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, isValidElement(children) && Children.only(children) && isForwardRef(children) ? cloneElement(children, __spreadValues(__spreadValues({}, props), childrenProps)) : /* @__PURE__ */ React.createElement(Box, {
    display: "inline-flex",
    ref: hoverRef
  }, isValidElement(children) && cloneElement(children, __spreadValues({}, props))), /* @__PURE__ */ React.createElement(Popper, {
    isOpen: !!content && open,
    ref: popperRef,
    anchorRef: hoverRef,
    transitionComponent: Fade,
    usePortal: true,
    popperOptions: {
      placement: position,
      modifiers: [
        {
          name: "offset",
          options: {
            offset: [0, 10]
          }
        }
      ]
    },
    zIndex: 2e3
  }, /* @__PURE__ */ React.createElement(Tooltip$1, {
    isInverted,
    maxWidth
  }, /* @__PURE__ */ React.createElement(Content, {
    size: fontSize
  }, content), hasArrow && /* @__PURE__ */ React.createElement(Popper.Arrow, null))));
};
const TooltipAdoptedForMobile = (_c) => {
  var _d = _c, { children } = _d, props = __objRest(_d, ["children"]);
  return /* @__PURE__ */ React.createElement(TooltipComponent, __spreadValues({}, props), children);
};
const Tooltip = maestroComponent("Tooltip", TooltipAdoptedForMobile);

export { Tooltip };
//# sourceMappingURL=Tooltip.es.js.map
